export default "__VITE_ASSET__21526167__"